// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../node_modules/rescript/lib/es6/curry.js";
import * as Logger$Catalyst from "../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ErrorUtils$Catalyst from "../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

function catchPromiseError(promise, requestUrl) {
  return promise.catch(function (error) {
              Logger$Catalyst.error("------promise caught error------");
              Logger$Catalyst.error(error);
              Curry._2(Lib$PorterinFusionkitSentry.React.capturePromiseErrorWithContext, error, {
                    tags: {
                      type: "API_ERROR_CONTRACT"
                    },
                    contexts: {
                      request: {
                        API_URL: requestUrl
                      }
                    }
                  });
              return Promise.resolve({
                          TAG: /* Error */1,
                          _0: ErrorUtils$Catalyst.getDefaultErrorEntity(JSON.stringify(error), undefined, undefined)
                        });
            });
}

export {
  catchPromiseError ,
  
}
/* Lib-PorterinFusionkitSentry Not a pure module */
